module.exports = __webpack_public_path__ + "img/o4.085bb9ce.jpg";